import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 137,
	height: 108,
	viewBox: "0 0 137 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 3L120.5 3",
			stroke: "currentColor",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2436 106.912C18.2199 107.888 19.8028 107.888 20.7791 106.912L36.689 91.0018C37.6653 90.0255 37.6653 88.4426 36.689 87.4662C35.7127 86.4899 34.1298 86.4899 33.1535 87.4662L19.0113 101.608L4.86921 87.4662C3.8929 86.4899 2.30999 86.4899 1.33368 87.4662C0.357369 88.4426 0.357369 90.0255 1.33368 91.0018L17.2436 106.912ZM16.5114 4.01123L16.5113 105.144L21.5113 105.144L21.5114 4.01123L16.5114 4.01123Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.2322 106.9C51.2085 107.877 52.7915 107.877 53.7678 106.9L69.6777 90.9906C70.654 90.0142 70.654 88.4313 69.6777 87.455C68.7014 86.4787 67.1184 86.4787 66.1421 87.455L52 101.597L37.8579 87.455C36.8816 86.4787 35.2986 86.4787 34.3223 87.455C33.346 88.4313 33.346 90.0142 34.3223 90.9906L50.2322 106.9ZM49.5 4L49.5 105.133L54.5 105.133L54.5 4L49.5 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.2322 106.9C86.2085 107.877 87.7915 107.877 88.7678 106.9L104.678 90.9906C105.654 90.0142 105.654 88.4313 104.678 87.455C103.701 86.4787 102.118 86.4787 101.142 87.455L87 101.597L72.8579 87.455C71.8815 86.4787 70.2986 86.4787 69.3223 87.455C68.346 88.4313 68.346 90.0142 69.3223 90.9906L85.2322 106.9ZM84.5 4L84.5 105.133L89.5 105.133L89.5 4L84.5 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.354 106.912C117.33 107.888 118.913 107.888 119.889 106.912L135.799 91.0018C136.775 90.0255 136.775 88.4426 135.799 87.4662C134.823 86.4899 133.24 86.4899 132.263 87.4662L118.121 101.608L103.979 87.4662C103.003 86.4899 101.42 86.4899 100.444 87.4662C99.4674 88.4426 99.4674 90.0255 100.444 91.0018L116.354 106.912ZM115.621 4.01123L115.621 105.144L120.621 105.144L120.621 4.01123L115.621 4.01123Z",
			fill: "currentColor"
		})
	]
});
export default SvgLoadsIcon;
